var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isIdeaSavedToAccount)?_c('UpVoteIdeaButton',{attrs:{"idea":_vm.idea}}):_c('SaveIdeaButton',{attrs:{"ideaId":_vm.idea.id,"focusIdeaOnSave":_vm.focusIdeaOnSave}})
}
var staticRenderFns = []

export { render, staticRenderFns }